import React from "react";
import { Box, Tabs, Tab, useTheme } from "@mui/material";

interface DtTabsProps {
    tabs: { label: string; icon?: React.ReactNode }[];
    value: number;
    onChange: (event: React.SyntheticEvent, newValue: number) => void;
    children: React.ReactNode[];
    sx?: object;
    tabPanelSx?: object;
    borderBottom?: boolean | string; // NEW PROP
}

const DtTabs: React.FC<DtTabsProps> = ({
    tabs,
    value,
    onChange,
    children,
    sx,
    tabPanelSx,
    borderBottom = false // NEW PROP
}) => {
    const theme = useTheme();

    return (
        <Box sx={{ width: "100%", ...sx }}>
            <Box
                sx={{
                    width: "100%",
                    borderBottom:
                        borderBottom
                            ? typeof borderBottom === "string"
                                ? borderBottom
                                : `2px solid ${theme.palette.divider}`
                            : undefined
                }}
            >
                <Tabs
                    value={value}
                    onChange={onChange}
                    aria-label="dt tabs"
                    variant={tabs.length > 4 ? "scrollable" : "standard"}
                    scrollButtons="auto"
                >
                    {tabs.map((tab, idx) => (
                        <Tab
                            key={tab.label}
                            label={tab.label}
                            icon={tab.icon && React.isValidElement(tab.icon) ? tab.icon : undefined}
                            iconPosition={tab.icon ? "start" : undefined}
                            id={`dt-tab-${idx}`}
                            aria-controls={`dt-tabpanel-${idx}`}
                            disableRipple
                        />
                    ))}
                </Tabs>
            </Box>
            {children.map((child, idx) => (
                <Box
                    key={idx}
                    role="tabpanel"
                    hidden={value !== idx}
                    id={`dt-tabpanel-${idx}`}
                    aria-labelledby={`dt-tab-${idx}`}
                    sx={{
                        pt: 1.5,
                        width: "100%",
                        ...(tabPanelSx || {})
                    }}
                >
                    {value === idx && child}
                </Box>
            ))}
        </Box>
    );
};

export default DtTabs;